module.exports = __webpack_public_path__ + "static/media/logo.3fcc606f.png";